import styled, { css } from 'styled-components/macro';

import { device } from 'components/styles/MediaQuery';

interface ScTooltipCommon {
  warning?: boolean;
  info?: boolean;
  success?: boolean;
  error?: boolean;
  marginBottom?: number;
}

export interface ScTooltipMessageProps extends ScTooltipCommon {
  clickable?: boolean;
}

export const ScTooltipMessage = styled.div<ScTooltipMessageProps>`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayColor6};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: ${({ marginBottom }) => marginBottom && `${marginBottom}px`};

  svg {
    width: 24px;
    height: 24px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .arrow {
    display: flex;
    transition: transform 0.2s;

    svg path {
      will-change: fill, fill-opacity;
      transition: fill-opacity 0.2s;
    }
  }

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

  @media (hover: hover) {
    &:hover {
      & > .arrow {
        transform: translateX(2px);

        svg path {
          fill-opacity: 1;
        }
      }
    }
  }
`;

export interface ScTooltipProps extends ScTooltipCommon {
  isAuthenticated: boolean;
  inline?: boolean;
  bottom?: number;
}

export const ScTooltip = styled.div<ScTooltipProps>`
  position: relative;
  white-space: pre-wrap;
  box-sizing: border-box;
  padding: 16px 48px 16px 56px;
  border-radius: 8px;
  text-transform: none;
  background: ${({ theme }) => theme.secondaryColor3};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3), 0px 10px 30px rgba(0, 0, 0, 0.3);
  .icon {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 24px;
    height: 24px;
    transform: translateY(-50%);
  }
  .title {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.whiteColor};
  }
  .text {
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.secondaryColor};
    margin-top: 4px;
  }
`;

export const ScTooltipGlobal = styled(ScTooltip)`
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 11111;
  max-width: 304px;
  background: ${({ theme }) => theme.grayColor5};
  border-radius: 12px;

  .button {
    margin-top: 12px;
  }

  @media (${device.mobile}) {
    right: 8px;
    bottom: ${({ bottom }) => bottom && `${bottom + 8}px`};
    left: auto;
    max-width: none;
    width: calc(100% - 16px);
  }
`;
